/**
 * Platform Definitions API
 * Platform Definitions Catalog API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = FullPower, 1 = Battery, 2 = LowPower
 */
export enum DevicePowerType {
    FullPower = 'full-power',
    Battery = 'battery',
    LowPower = 'low-power'
}

